module.exports = __webpack_public_path__ + "media/images/reserve_double_sp-8aab43bb968b8dcc4cb1d52fedecf1ee.png";